// HomePageHeader.jsx
// TK 3/28/2k22

// Packages, Dependencies, Shared Libraries
import React from "react";
import { useNavigate } from "react-router-dom";
import { openInNewTab } from "../sharedFunctions";

// Images
import logo from "../Images/HomePage/LeafLings.png";
import instagramLogo from "../Images/SocialMedia/instagram_glyph.png";
import tiktokLogo from "../Images/SocialMedia/tiktokLogo.png";

// Constants
import * as constants from "../constants";

// React Components
import SocialMediaIcon from "../HomePage/SocialMediaIcon";

/*******************************************************************************
 * @func HomePageHeader (React Component)
 * This component has the logo and the social media icons that appear at the top
 * of the page.
 *
 * @param None
 * @return JSX Element
 *
 * @notes Clicking on the logo takes the user home and clicking on the social
 * media icons takes them to the social media page.
 *
 ******************************************************************************/
const HomePageHeader = () => {
  const navigate = useNavigate();

  return (
    <header className="sticky top-0 z-40 bg-global-bg/90 backdrop-blur-sm border-b border-leaf-brown/10">
      <div className="mx-auto max-w-5xl px-4 py-2 flex items-center justify-between">
        <img
          className="w-[140px] sm:w-[170px] cursor-pointer hover:opacity-80 transition-opacity"
          src={logo}
          alt="Leaflings"
          onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
        />
        <div className="flex items-center gap-1 sm:gap-3">
          <nav className="flex items-center gap-3 sm:gap-4 mr-1 sm:mr-2 font-global font-bold text-sm text-leaf-green-dark">
            <button
              className="hover:text-leaf-green transition-colors"
              onClick={() => navigate("/game")}
            >
              Game
            </button>
            <button
              className="hover:text-leaf-green transition-colors"
              onClick={() => navigate("/me")}
            >
              My garden
            </button>
          </nav>
          <SocialMediaIcon
            logoRelPath={instagramLogo}
            link={constants.INSTAGRAM_URL}
          />
          <SocialMediaIcon
            logoRelPath={tiktokLogo}
            link={constants.TIKTOK_URL}
          />
          <button
            className="hidden sm:block button text-sm"
            onClick={() => openInNewTab(constants.APP_STORE_URL)}
          >
            Get the app
          </button>
        </div>
      </div>
    </header>
  );
}; // End HomePageHeader

export default HomePageHeader;
